/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Mohak Gupta",
  title: "Hi all, I'm Mohak",
  subTitle: emoji(
    "Ambitious and outcome-driven blockchain developer 🚀 with a strong foundation in scalable decentralized applications and smart contract development. Proven ability to lead product launches, secure funding, and manage high-traffic systems."
  ),
  resumeLink:
    "https://drive.google.com/file/d/19HbggIIHwJ7-Au4vCAgwf208ZkUAAwno/view", // Link to Google Drive resume
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/mo-hak",
  linkedin: "https://www.linkedin.com/in/mohak-gupta-756090225/",
  gmail: "mohakgupta100@gmail.com",
  twitter: "https://x.com/mohak_sol",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "BLOCKCHAIN DEVELOPER WHO LOVES TO EXPLORE DEFI AND WEB3 ECOSYSTEM",
  skills: [
    emoji(
      "⚡ Develop scalable decentralized applications and smart contracts on multiple blockchains"
    ),
    emoji("⚡ Build DeFi protocols with advanced features like hooks, liquidity management, and cross-chain functionality"),
    emoji(
      "⚡ Integration of Web3 technologies including oracles, account abstraction, and real-world asset tokenization"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "solidity",
      fontAwesomeClassname: "fab fa-ethereum"
    },
    {
      skillName: "javascript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "typescript",
      fontAwesomeClassname: "fab fa-js-square"
    },
    {
      skillName: "rust",
      fontAwesomeClassname: "fab fa-rust"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "The LNM Institute of Information Technology",
      logo: require("./assets/images/lnmiitLogo.png"),
      subHeader: "BTech-MTech Computer Science and Engineering",
      duration: "December 2021 - May 2026",
      desc: "Currently pursuing integrated BTech-MTech degree with focus on blockchain technology and distributed systems.",
      descBullets: [
        "Specialized in blockchain security research through LUSIP internship",
        "Active in Web3 ecosystem with multiple successful project launches",
        "President of college dance society, leading teams to secure national-level podium finishes in competitions"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Blockchain/Web3", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend/Backend",
      progressPercentage: "85%"
    },
    {
      Stack: "Smart Contracts",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Developer Ambassador",
      company: "Uniswap Foundation",
      companylogo: require("./assets/images/uniswapLogo.png"),
      date: "February 2025 – Present",
      desc: "Build and maintain community-focused developer tools and resources to support adoption of Uniswap v4 and Unichain.",
      descBullets: [
        "Lead community engagement across Discord, forums, and social media platforms",
        "Organize and host local meetups, technical workshops, and virtual sessions to educate developers"
      ]
    },
    {
      role: "Full Stack Blockchain Developer Intern",
      company: "Goequitize",
      companylogo: require("./assets/images/goequitizeLogo.png"),
      date: "June 2024 – July 2024",
      desc: "Maintained and improved smart contracts for real-world asset tokenization using Chainlink Functions and CCIP, enabling secure cross-chain ownership.",
      descBullets: [
        "Enhanced user onboarding via Biconomy-based account abstraction",
        "Worked with microservices architecture and integrated RESTful APIs"
      ]
    },
    {
      role: "Blockchain Security Research Intern",
      company: "LUSIP at LNMIIT",
      companylogo: require("./assets/images/lnmiitLogo.png"),
      date: "May 2023 – July 2023",
      desc: "Conducted blockchain security research and found a minor bug in Uniswap v4-core repository.",
      descBullets: [
        "Gained expertise in smart contract security and Solidity vulnerabilities",
        "Solved security CTFs including Ethernaut and Damn Vulnerable DeFi"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "BLOCKCHAIN PROJECTS AND DAPPS THAT I HAVE BUILT WITH CUTTING-EDGE TECHNOLOGIES",
  projects: [
    {
      image: require("./assets/images/dynamicLPLogo.webp"),
      projectName: "Dynamic LP Assurance Hook",
      projectDesc: "Developed a dynamic insurance pool system leveraging Uniswap V4 hooks and Arbitrum Stylus enabling efficient LP protection with ERC-6909-based token tracking.",
      footerLink: [
        {
          name: "View Project",
          url: "https://bouncy-print-988.notion.site/Dynamic-LP-Assurance-Hook-1565f0444abe813babf8cc97f6a1bbc6"
        }
      ]
    },
    {
      image: require("./assets/images/admojoLogo.webp"),
      projectName: "AdMojo",
      projectDesc: "Designed and developed a Web3 advertising platform integrating IoT devices with real-time on-chain event tracking via oracles. Built with Next.js, TypeScript, and Solana.",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/admojo-protocol"
        }
      ]
    },
    {
      image: require("./assets/images/brainpowerLogo.webp"),
      projectName: "BrainPower",
      projectDesc: "Contributed to the development of a DeFi-focused AI agent on Solana, enabling users to perform crypto operations through natural language.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.brainpower.sh/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Recognition 🏆 "),
  subtitle:
    "Awards, Grants, Bounties and Recognition that showcase my contributions to the Web3 ecosystem!",

  achievementsCards: [
    {
      title: "Uniswap Hook Incubator Fellow",
      subtitle:
        "Selected for a two-month fellowship with the Uniswap Hook Incubator and secured 2nd place in the Hookathon, winning $3500 for the Dynamic LP Assurance Hook project.",
      image: require("./assets/images/uniswapLogo.png"),
      imageAlt: "Uniswap Logo",
      footerLink: [
        {
          name: "View Project",
          url: "https://bouncy-print-988.notion.site/Dynamic-LP-Assurance-Hook-1565f0444abe813babf8cc97f6a1bbc6"
        }
      ]
    },
    {
      title: "Superteam Grant Recipient",
      subtitle:
        "Received a $6,000 grant from Superteam for the AdMojo project, recognizing its potential in the Web3 advertising space.",
      image: require("./assets/images/superteamLogo.webp"),
      imageAlt: "Superteam Logo",
      footerLink: [
        {
          name: "View Project",
          url: "https://github.com/admojo-protocol"
        }
      ]
    },
    {
      title: "BrainPower Project Success",
      subtitle: "Secured $13,000 funding and successfully launched token reaching peak market cap of $1.4M. Led technical development and launch strategies.",
      image: require("./assets/images/brainpowerLogo.webp"),
      imageAlt: "BrainPower Logo",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.brainpower.sh/"
        }
      ]
    },
    {
      title: "Open Source Contributor",
      subtitle: "Won bounty awards and contributed to open-source Web3 protocols like Fuel Labs, ConsenSys, implementing features and reporting critical issues.",
      image: require("./assets/images/opensourceLogo.webp"),
      imageAlt: "Open Source Logo",
      footerLink: [
        {
          name: "View GitHub",
          url: "https://github.com/mo-hak"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section - DISABLED as not mentioned in resume

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections - DISABLED as not mentioned in resume

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),
  talks: [],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section - DISABLED as not mentioned in resume

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a blockchain project or just want to say hi? My Inbox is open for all.",
  number: "+91-7413885561",
  email_address: "mohakgupta100@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "mohak_sol", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
